import React, { useState, useEffect } from "react";
import axios from "axios";

const ProjectUCDetails = () => {
  const [projectId, setProjectId] = useState("");
  const [ucDate, setUcDate] = useState("");
  const [filename, setFilename] = useState("");
  const [document, setDocument] = useState("");
  const [data, setData] = useState([]);

  // Load projectId from localStorage on mount
  useEffect(() => {
    const storedProjId = localStorage.getItem("projId");
    if (storedProjId) {
      setProjectId(storedProjId);
      handleFetchData(storedProjId); // Fetch data automatically
    }
  }, []);

  // Handle file upload and convert to Base64
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const fileNameWithoutExt = file.name.replace(/\.(pdf|doc|docx)$/, "");
        setFilename(fileNameWithoutExt);
        setDocument(reader.result.split(",")[1]); // Extract Base64 content
      };
      reader.readAsDataURL(file);
    }
  };

  // Fetch data based on projectId
  const handleFetchData = async (id) => {
    const projId = id || projectId;
    
    if (!projId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/projectucdetails/project/${projId.split(" - ")[0]}`
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const projIdOnly = projectId.split(" - ")[0]; // Extract only the ID
  
      const postData = { 
        projectId: projIdOnly, 
        ucDate, 
        ucDocument: document, 
        filename 
      };
  
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/projectucdetails/create`, postData);
      alert("Data submitted successfully");
      handleFetchData(); // Refresh table after submission
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  

  return (
    <div className="container mt-5">
       <div className="row">
       <div className="col-md-6">
       <h2 className="mb-4">Project UC Document Upload</h2>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Project ID"
        value={projectId}
        readOnly // Prevent user modification
      />

      <form onSubmit={handleSubmit} className="shadow p-4 bg-light rounded">
        <div className="mb-3">
        <label className="form-label"> Date </label> 
        <input
          type="date"
           className="form-control"
          value={ucDate}
          onChange={(e) => setUcDate(e.target.value)}
          required
        />
        </div>
        <div className="mb-3">
        <label className="form-label">Upload Document (PDF or Doc)</label>
        <input type="file"  className="form-control" accept=".pdf,.doc,.docx" onChange={handleFileChange} required />
        </div>
        <button type="submit" className="btn btn-primary">Submit</button>
      </form>
</div>
<div className="col-md-6">
  <h2 className="mb-4">Project Details</h2>
  <div
    className="table-responsive shadow bg-white rounded"
    style={{ maxHeight: "400px", overflowY: "auto" }}
  >
  
      {data.length > 0 && (
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Project ID</th>
              <th>UC Date</th>
              <th>UC Document</th>
              <th>View Document</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.id.projectId}</td>
                <td>{item.id.ucDate}</td>
                <td>{item.ucDocument}</td>
                <td>            
  <a href={`${process.env.REACT_APP_FILE_URL || 'https://ooo-toddler-gifts-pubs.trycloudflare.comloudflare.com'}/uploads/${item.ucDocument}`} target="_blank" rel="noopener noreferrer">
    View Document
  </a></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      </div>
    </div>
          </div>
         </div>
  );
};

export default ProjectUCDetails;
